module.exports = __webpack_public_path__ + "static/assets/49c0b650a4adf0b331672c1182a5caa7.png";